import { inject, Injectable, RendererFactory2 } from '@angular/core';
import { SecurityManagerService } from '@core/security-manager/security-manager.service';
import { Affiliation } from '@gandalf/constants';
import { DocumentService } from 'majora';

@Injectable({
	providedIn: 'root',
})
export class LiveChatService {
	private securityManager = inject(SecurityManagerService);
	private documentService = inject(DocumentService);
	private rendererFactory = inject(RendererFactory2);

	initialized = false;

	readonly widgetOrigin = 'https://supportwidget.pteksupport.com';
	readonly brand = 'revehr';
	readonly contactBrand = 'RevEHR';
	readonly iframeTitle = 'RevolutionEHR chat';

	initialize() {
		if (this.initialized) {
			return;
		}
		if (this.securityManager.hasAffiliation(Affiliation.AFFILIATE_WALMART_EMPLOYED.value)) {
			return;
		}
		this.initialized = true;

		const userSession = this.securityManager.getUserSession();
		const widgetOrigin = this.widgetOrigin;
		const renderer = this.rendererFactory.createRenderer(null, null);

		this.documentService.loadJavascript(renderer, `${widgetOrigin}/ac-widget-host.js`)
			.then(() => {
				const initAcWidget = (window as any).initAcWidget;
				if (typeof initAcWidget !== 'function') {
					console.error('ac-widget: initAcWidget not available after host script load');
					return;
				}
				initAcWidget({
					widgetOrigin,
					brand: this.brand,
					iframeTitle: this.iframeTitle,
					onReady: (iframe: HTMLIFrameElement) => {
						iframe.contentWindow?.postMessage({
							source: 'ac-widget-host',
							action: 'setConfig',
							patch: {
								prechatEnabled: false,
								contactDefaults: {
									firstName: userSession.userFirstName,
									lastName: userSession.userLastName,
									email: userSession.userEmail,
									ecrId: String(userSession.userEntityId),
									brand: this.contactBrand,
								},
							},
						}, widgetOrigin);
					},
				});
			})
			.catch(() => console.error('ac-widget: host script failed to load'));
	}
}
